export const formateDate = (dateString) => {
  return new Date(dateString).toLocaleDateString({
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
